"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removePropertiesContaining = exports.getCredentials = exports.getAuthoriserResponse = exports.getMimeTypeFromBase64 = exports.addMinutesToNow = exports.ttl = exports.now = exports.connectResponse = exports.getSessionAttributes = exports.getEventBody = exports.getAccessControlHeaderValueFromEvent = exports._204 = exports._500 = exports._422 = exports._409 = exports._405 = exports._404 = exports._403 = exports._401 = exports._400 = exports._301 = exports.inProgress = exports.ok = exports.isScheduledEvent = exports.incrementMetric = void 0;
const sts_1 = __importDefault(require("aws-sdk/clients/sts"));
const url = __importStar(require("url"));
const aws_sdk_1 = require("aws-sdk");
const incrementMetric = async ({ name, credentials, namespace, dimensions, incrementBy = 1, }) => {
    try {
        const cw = new aws_sdk_1.CloudWatch(credentials);
        const response = await cw
            .putMetricData({
            Namespace: namespace,
            MetricData: [
                {
                    MetricName: name,
                    Value: incrementBy,
                    Timestamp: new Date(),
                    Unit: 'Count',
                    Dimensions: [
                        {
                            Name: 'Stage',
                            Value: process.env.STAGE || 'dev',
                        },
                        ...dimensions,
                    ].filter((value, index, self) => index === self.findIndex(t => t.Name === value.Name)), // Remove duplicate Name values. Prevents errors if this function is passed another Stage dimension
                },
            ],
        })
            .promise();
        console.info(`CloudWatch Monitoring Put Metric ::: `, response);
    }
    catch (ex) {
        const err = ex.message;
        console.error(`CloudWatch Monitoring Error Putting Metric ${err}`);
    }
};
exports.incrementMetric = incrementMetric;
function isScheduledEvent(event) {
    if (event['detail-type'] === 'Scheduled Event') {
        return true;
    }
    return false;
}
exports.isScheduledEvent = isScheduledEvent;
function ok(data, headers = {}) {
    console.log('ok', data);
    return {
        statusCode: 200,
        body: typeof data === 'string' ? data : JSON.stringify(data),
        headers: Object.assign(Object.assign({}, headers), { 'Access-Control-Allow-Origin': '*' }),
    };
}
exports.ok = ok;
function inProgress(data, headers = {}) {
    console.log('in progress', data);
    return {
        statusCode: 202,
        body: typeof data === 'string' ? data : JSON.stringify(data),
        headers: Object.assign(Object.assign({}, headers), { 'Access-Control-Allow-Origin': '*' }),
    };
}
exports.inProgress = inProgress;
function _301(url) {
    console.log('301', url);
    return {
        statusCode: 301,
        headers: {
            Location: url,
            'Access-Control-Allow-Origin': '*',
        },
        body: 'Redirected',
    };
}
exports._301 = _301;
function _400(err) {
    console.log('400', err);
    return {
        statusCode: 400,
        body: JSON.stringify({
            error: err || 'Bad Request',
        }),
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
    };
}
exports._400 = _400;
function _401(err) {
    console.log('401', err);
    return {
        statusCode: 401,
        body: JSON.stringify({
            error: err || 'Unauthorized',
        }),
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
    };
}
exports._401 = _401;
const _403 = (err) => ({
    statusCode: 403,
    body: JSON.stringify({
        error: err || 'Forbidden',
    }),
    headers: {
        'Access-Control-Allow-Origin': '*',
    },
});
exports._403 = _403;
function _404(name, ID) {
    console.log('404', name, ID);
    return {
        statusCode: 404,
        body: JSON.stringify({
            error: `${name} with ID ${ID} not found`,
        }),
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
    };
}
exports._404 = _404;
function _405(err) {
    console.log('405', err);
    return {
        statusCode: 405,
        body: JSON.stringify({
            error: typeof err === 'object' ? JSON.stringify(err) : err,
        }),
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
    };
}
exports._405 = _405;
function _409(err) {
    console.log('409', err);
    return {
        statusCode: 409,
        body: JSON.stringify({
            error: typeof err === 'object' ? JSON.stringify(err) : err,
        }),
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
    };
}
exports._409 = _409;
function _422(err) {
    console.log('422', err);
    return {
        statusCode: 422,
        body: JSON.stringify({
            error: err || 'Unprocessable Entity',
        }),
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
    };
}
exports._422 = _422;
function _500(err) {
    console.log('500', err);
    return {
        statusCode: 500,
        body: err
            ? JSON.stringify({
                error: typeof err === 'object' ? JSON.stringify(err) : err,
            })
            : 'Internal Server Error',
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
    };
}
exports._500 = _500;
function _204() {
    console.log('204');
    return {
        statusCode: 204,
        headers: {
            'Access-Control-Allow-Origin': '*',
        },
    };
}
exports._204 = _204;
function getAccessControlHeaderValueFromEvent(event) {
    //Returns the value to be used as Access-Control-Allow-Origin header on response.
    //We only want to allow *.smartagent.app, and localhost (both on any port, any protocol)
    //We check if the Host header (the page posting up) is an allowed value..
    //..if it is, we return the host header value, which will be the value..
    //..that will get set as the Access-Control-Allow-Origin on the response, ..
    //..thus allowing the page to hit the api
    var _a, _b;
    /*
    ┬────────────────────────┬
    │          host          │
    ├─────────────────┬──────┼
    │    hostname     │ port │
    ├─────────────────┴──────┤
    │ sub.example.com : 8080 │
    ┼────────────────────────┤
    */
    if (((_a = event.headers) === null || _a === void 0 ? void 0 : _a.origin) || event.headers.origin) {
        const origin = ((_b = event.headers) === null || _b === void 0 ? void 0 : _b.origin) || event.headers.origin;
        try {
            let originUrl = new url.URL(origin);
            let hostname = originUrl.hostname;
            let parts = hostname.split('.').reverse(); // i.e. ['app', 'smartagent', 'jd']
            if (parts[0] === 'app' && parts[1] === 'smartagent')
                return origin; //allow *.smartagent.app[:*]
            if (parts[0] === 'localhost' && parts.length === 1)
                return origin; //allow localhost[:*]
        }
        catch (e) {
            return 'null';
        }
    }
    return 'null';
}
exports.getAccessControlHeaderValueFromEvent = getAccessControlHeaderValueFromEvent;
function getEventBody(event) {
    if (!event.body)
        return {};
    if (typeof event.body === 'string')
        return JSON.parse(event.body);
    return event.body;
}
exports.getEventBody = getEventBody;
const getSessionAttributes = (connectEvent) => {
    var _a, _b, _c, _d;
    if (!((_b = (_a = connectEvent === null || connectEvent === void 0 ? void 0 : connectEvent.Details) === null || _a === void 0 ? void 0 : _a.Parameters) === null || _b === void 0 ? void 0 : _b['session-attributes']))
        return {};
    return JSON.parse((_d = (_c = connectEvent === null || connectEvent === void 0 ? void 0 : connectEvent.Details) === null || _c === void 0 ? void 0 : _c.Parameters) === null || _d === void 0 ? void 0 : _d['session-attributes']);
};
exports.getSessionAttributes = getSessionAttributes;
const connectResponse = (response, sessionAttributes) => {
    for (let key in sessionAttributes) {
        if (!response.hasOwnProperty(key)) {
            response[key] = sessionAttributes[key];
        }
    }
    response['session-attributes'] = JSON.stringify(response);
    console.log('Returning response ..', response);
    return response;
};
exports.connectResponse = connectResponse;
function now() {
    return new Date().getTime();
}
exports.now = now;
function ttl(date) {
    return Math.floor(date.getTime() / 1000);
}
exports.ttl = ttl;
function addMinutesToNow(mins) {
    const now = new Date();
    now.setTime(now.getTime() + mins * 1000 * 60);
    return now;
}
exports.addMinutesToNow = addMinutesToNow;
function getMimeTypeFromBase64(string) {
    const parts = string.split(',');
    if (!parts || !parts.length)
        throw 'Unable to determine mime type';
    return {
        mime: parts[0].split(':')[1].split(';')[0],
        base64: parts[1],
    };
}
exports.getMimeTypeFromBase64 = getMimeTypeFromBase64;
const getAuthoriserResponse = (effect = 'Deny', id = 'token', resource) => {
    return {
        principalId: id,
        policyDocument: {
            Version: '2012-10-17',
            Statement: [
                {
                    Action: 'execute-api:Invoke',
                    Effect: effect,
                    Resource: resource,
                },
            ],
        },
    };
};
exports.getAuthoriserResponse = getAuthoriserResponse;
const getCredentials = async (roleName, accountID, externalID, region, RoleSessionName) => {
    const role = await new sts_1.default()
        .assumeRole({
        RoleArn: `arn:aws:iam::${accountID}:role/${roleName}`,
        ExternalId: externalID,
        RoleSessionName: RoleSessionName !== null && RoleSessionName !== void 0 ? RoleSessionName : roleName,
    })
        .promise();
    if (!role.Credentials)
        throw 'Failed to assume role';
    return {
        accessKeyId: role.Credentials.AccessKeyId,
        secretAccessKey: role.Credentials.SecretAccessKey,
        sessionToken: role.Credentials.SessionToken,
        expiry: role.Credentials.Expiration,
        region,
    };
};
exports.getCredentials = getCredentials;
const removePropertiesContaining = (object, keyMatches) => {
    Object.keys(object).some(k => {
        keyMatches.forEach(keyMatch => {
            if (k.toLowerCase().includes(keyMatch.toLowerCase())) {
                delete object[k];
                return true;
            }
            if (object[k] && typeof object[k] === 'object')
                object[k] = (0, exports.removePropertiesContaining)(object[k], keyMatches);
            return false;
        });
    });
    return object;
};
exports.removePropertiesContaining = removePropertiesContaining;
